export default "__VITE_ASSET__OraR0ndc__"